module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"property":"Liegenschaft","benchmarkTitle":"REIDA Benchmark {year}"}}')
  delete Component.options._Ctor
}
